let listDongtai=[
    {name:"公司动态",type:'a',
        list:[
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/1.jpg'), time:'2025-08-18',title: "活动 | 开学能量补给站，满电启程新学期！",see:192,id:121 ,type:'a',
            imglIst:[require('../assets/image/all/1-1.jpg'),require('../assets/image//all/1-2.jpg'),
                require('../assets/image//all/1-3.jpg')]
},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/2.jpg'), time:'2025-08-18',title: "步步高中央厨房 · 焙特丽芙 | 用心烘焙，只为一口好味",see:192,
                id:122 ,type:'a',
                imglIst:[require('../assets/image/all/2-1.jpg'),require('../assets/image//all/2-2.jpg'),
                    require('../assets/image//all/2-3.jpg'),require('../assets/image//all/2-4.jpg')]},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/3.jpg'), time:'2025-07-31',title: "步步高自有品牌新品上市",see:212,id:123,type:'a',
                imglIst:[require('../assets/image/all/3-1.jpg'),require('../assets/image//all/3-2.jpg'),
                    require('../assets/image//all/3-3.jpg')]},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/4.jpg'), time:'2025-07-31',title: "汇米+ | 打开“汇米+”小程序，动动手指，好物轻松带回家！",
                see:172,id:124,type:'a',
                imglIst:[require('../assets/image/all/4-1.jpg'),require('../assets/image//all/4-2.jpg'),
                    require('../assets/image//all/4-3.jpg')]},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/5.jpg'), time:'025-07-31',title: "活动 | 尽享夏日的美好与活力，一起畅饮一夏，冰力全开！",see:2 ,
                id:125,type:'a',
                imglIst:[require('../assets/image/all/5-1.jpg'),require('../assets/image//all/5-2.jpg'),
                    require('../assets/image//all/5-3.jpg')]}
        ]
    },
    {name:"汇米巴故事",type:'b',
        list:[
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/2-1.png'), time:'2022-08-17',title: "\t\n" +
                    "感恩母亲节，ta们这样做",see:292,id:126,type:'b',
                imglIst:[require('../assets/image/all/6-1.jpg')]},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/2-2.jpg'), time:'2020-02-25',title: "\t\n" +
                    "“没事，我这里还能扛住！”“都是老顾客，能帮就帮！”",see:792,id:127 ,type:'b'},
        ]
    },
    {name:"会员活动",type:'c',
        list:[
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/3-1.jpg'), time:'2024-05-06',title:
                    "活动 | 喂，说你呢！还在为夏日干渴犯愁？水饮",see:192,id:128,type:'c',
                imglIst:[require('../assets/image/all/7-1.jpg'),require('../assets/image/all/7-2.jpg'),
                    require('../assets/image/all/7-3.jpg'),require('../assets/image/all/7-3.jpg')]},
            { name:'汇米巴',img: require('../assets/image/dongtaiimg/3-2.jpg'), time:'2024-05-06',title:
                    "新宠儿 | 随时给你温暖‘饱’护，快来尝鲜，让",see:114,id:129,type:'c',
                imglIst:[require('../assets/image/all/8-1.jpg'),require('../assets/image/all/8-2.jpg'),
                    require('../assets/image/all/8-3.jpg')]},
        ]
    },
]

let listmeishi=[
    {name:"营养便当",
        list:[
            { name:'翡翠白玉牛肉拌',img: require('../assets/image/2-200612222502-50.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 },
            { name:'香辣卤味盖浇饭',img: require('../assets/image/bf.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 },
        ]
    },
    {name:"方便饭团",
        list:[
            { name:'新奥尔良鸡腿',img: require('../assets/image/2-20042GT917.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 }
        ]
    },
    {name:"和风寿司",
        list:[
            { name:'扇形组合寿司',img: require('../assets/image/2-20042G93247.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 }
        ]
    },  {name:"经典风味粉面",
        list:[
            { name:'炸酱面',img: require('../assets/image/2-20042H02404.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 }
        ]
    },  {name:"营养汤粥",
        list:[
            { name:'皮蛋瘦肉粥',img: require('../assets/image/2-20042H03I8.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 }
        ]
    },  {name:"美味卤菜",
        list:[
            { name:'卤味鸭脖（和气',img: require('../assets/image/2-20042H05056.jpg'), time:'2025-08-21',title: "活动 | 开学能量补给站，满电启程新学期！",see:192 }
        ]
    },
    {name:"风味蛋类",
        list:[
        ]
    },
]


export default {listDongtai, listmeishi};



